const PRICEBOOK_ENABLED_STORE_IDS = new Set([
  'c05071ba-066f-464a-b937-de757efe1451',
  'ac3c7709-fb72-414e-9b57-b878e829cec3',
  'b6a7de00-304a-4168-95cd-b81650718c6d',
  'cc768f56-fb17-418b-9ba8-d6b8ec1dd3d0',
]);

export interface StoreRouteAccessSource {
  id?: string;
  pos_type?: string | null;
  sync_games_to_pos?: boolean | null;
}

export interface StoreRouteAccess {
  canAccessSales: boolean;
  canAccessGames: boolean;
  canAccessPricebook: boolean;
}

export const canAccessSalesRoute = (store?: StoreRouteAccessSource | null) => (
  Boolean(store?.pos_type && String(store.pos_type).toLowerCase() !== 'n/a')
);

export const canAccessGamesRoute = (store?: StoreRouteAccessSource | null) => (
  Boolean(store?.sync_games_to_pos)
);

export const canAccessPricebookRoute = (
  store?: StoreRouteAccessSource | null
) => {
  const isAllowedStore = Boolean(store?.id && PRICEBOOK_ENABLED_STORE_IDS.has(store.id));
  const isSupportedPosType = store?.pos_type === 'GilbarcoPassportPJR';

  return isAllowedStore && (isSupportedPosType || store?.id === 'cc768f56-fb17-418b-9ba8-d6b8ec1dd3d0');
};

export const getStoreRouteAccess = (store?: StoreRouteAccessSource | null): StoreRouteAccess => ({
  canAccessSales: canAccessSalesRoute(store),
  canAccessGames: canAccessGamesRoute(store),
  canAccessPricebook: canAccessPricebookRoute(store),
});

export const shouldRedirectStoreRoute = (pathname: string, routeAccess: StoreRouteAccess) => {
  if (pathname.includes('/sales') && !routeAccess.canAccessSales) {
    return true;
  }

  if (pathname.includes('/games') && !routeAccess.canAccessGames) {
    return true;
  }

  if (pathname.includes('/pricebook') && !routeAccess.canAccessPricebook) {
    return true;
  }

  return false;
};
